import { NgModule, LOCALE_ID } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AntDModule } from 'src/app/modules/shared/antd.module';
import { NgbModalModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgLabelTemplateDirective, NgOptionTemplateDirective, NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import { SharedModule } from 'src/app/modules/shared/shared.module';
import { ApiKeyComponent } from './api-key/api-key.component';
import { ReferrerComponent } from './referrer/referrer.component';
import { WebhookDetailComponent } from './webhook/webhook-detail/webhook-detail.component';
import { provideMarkdown, MarkdownModule } from 'ngx-markdown';
import { WebhookShippingComponent } from './referrer/components/webhook-shipping/webhook-shipping.component';
import { ReferrerWhitelistComponent } from './referrer/components/referrer-whitelist/referrer-whitelist.component';
import { MobileKeyComponent } from './referrer/components/mobile-key/mobile-key.component';
import { ModalAddWebhookComponent } from './referrer/components/modal-add-webhook/modal-add-webhook.component';
import { ModalAddReferrerComponent } from './referrer/components/modal-add-referrer/modal-add-referrer.component';
import { ModalAddMobKeyComponent } from './referrer/components/modal-add-mob-key/modal-add-mob-key.component';
import { ModalDeleteReferrerComponent } from './referrer/components/modal-delete-referrer/modal-delete-referrer.component';
import { WebhookPaymentComponent } from './webhook/webhook-payment/webhook-payment.component';
import { LibsModule } from 'src/app/libs/libs.module';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { WebhookQrislyComponent } from './webhook/webhook-qrisly/webhook-qrisly.component';
import { ApkWebhookComponent } from './webhook/webhook-qrisly/components/apk-webhook/apk-webhook.component';
import { ModalGenerateConfigComponent } from './webhook/webhook-qrisly/components/modal-generate-config/modal-generate-config.component';
import { OutbondWebhookComponent } from './webhook/webhook-qrisly/components/outbond-webhook/outbond-webhook.component';
import { DeliveryWebhookComponent } from './webhook/webhook-qrisly/components/delivery-webhook/delivery-webhook.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { NzTableModule } from 'ng-zorro-antd/table';
import { DownloadApkModalComponent } from './webhook/download-apk-modal/download-apk-modal.component';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { IntegrationRoutingModule } from './integration-routing.module';

import { IntegrationComponent } from './integration.component';
import { WebhookComponent } from './webhook/webhook.component';

@NgModule({
    declarations: [
        IntegrationComponent,
        WebhookComponent,
        ApiKeyComponent,
        ReferrerComponent,
        WebhookDetailComponent,
        WebhookShippingComponent,
        ReferrerWhitelistComponent,
        MobileKeyComponent,
        ModalAddWebhookComponent,
        ModalAddReferrerComponent,
        ModalAddMobKeyComponent,
        ModalDeleteReferrerComponent,
        WebhookPaymentComponent,
        WebhookQrislyComponent,
        ApkWebhookComponent,
        ModalGenerateConfigComponent,
        OutbondWebhookComponent,
        DeliveryWebhookComponent,
        DownloadApkModalComponent
    ],
    providers: [{ provide: LOCALE_ID, useValue: 'en-US' }, provideMarkdown()],
    imports: [
    CommonModule,
    NgbModalModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    AntDModule,
    NgbModule,
    LibsModule,
    NgLabelTemplateDirective,
    NgOptionTemplateDirective,
    NgSelectComponent,
    NgSelectModule,
    MarkdownModule.forRoot(),
    NgxDaterangepickerMd,
    ScrollingModule,
    NzTableModule,
    NzButtonModule,
    CommonModule,
    NzMessageModule,
    IntegrationRoutingModule
],
    exports: [
        IntegrationComponent,
        WebhookComponent,
        ApiKeyComponent,
        ReferrerComponent,
        WebhookDetailComponent,
        WebhookShippingComponent,
        ReferrerWhitelistComponent,
        MobileKeyComponent,
        WebhookPaymentComponent,
        WebhookQrislyComponent,
        ApkWebhookComponent,
        ModalGenerateConfigComponent,
        OutbondWebhookComponent,
    ],
})
export class IntegrationModule { }
